import { axios } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { useMutation } from 'react-query';

export const createKeyDefinition = ({ data, keyDefinitionId }) => {
  if (keyDefinitionId === 'new-definition')
    return axios.post(`/api/v1/agent/metric`, data);
};

export const useCreateKeyDefinition = () => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onError: (data) => {
      addNotification({
        type: 'error',
        title:
          data?.response?.data?.error?.message ||
          `Failed to Add Key Definition`,
      });
    },
    onSuccess: async (data, { keyDefinitionName }) => {
      addNotification({
        type: 'success',
        title: keyDefinitionName
          ? `${keyDefinitionName} Added Successfully`
          : `Key Definition Added Successfully`,
      });
      queryClient.refetchQueries('getConnectedDefinitionsList');
    },
    // ...config,
    mutationFn: createKeyDefinition,
  });
};
